// extracted by mini-css-extract-plugin
var _1 = "55px";
var _2 = "38px";
var _3 = "38px";
var _4 = "90px";
var _5 = "80px";
var _6 = "30px";
var _7 = "20px";
var _8 = "0px";
var _9 = "ra-quiz-image-question-buttons";
var _a = "ra-quiz-image-question-buttons-container";
var _b = "ra-quiz-image-question";
var _c = "ra-quiz-image-question-image";
var _d = "ra-quiz-image-question-overlay";
var _e = "ra-quiz-image-question-overlay-dislike";
var _f = "ra-quiz-image-question-overlay-dislike-icon";
var _10 = "ra-quiz-image-question-overlay-like";
var _11 = "ra-quiz-image-question-overlay-like-icon";
var _12 = "ra-quiz-image-question-text";
var _13 = "21px";
var _14 = "81px";
var _15 = "69px";
var _16 = "69px";
var _17 = "141px";
var _18 = "342px";
var _19 = "282px";
export { _1 as "browserAddressbarHeight", _2 as "imageControlsMdHeight", _3 as "imageControlsSmHeight", _4 as "imageTitleMdHeight", _5 as "imageTitleSmHeight", _6 as "quizImageItemMarginLg", _7 as "quizImageItemMarginMd", _8 as "quizImageItemMarginSm", _9 as "quizImageSliderQuestionButtonsCls", _a as "quizImageSliderQuestionButtonsContainerCls", _b as "quizImageSliderQuestionCls", _c as "quizImageSliderQuestionImageCls", _d as "quizImageSliderQuestionOverlayCls", _e as "quizImageSliderQuestionOverlayDislikeCls", _f as "quizImageSliderQuestionOverlayDislikeIconCls", _10 as "quizImageSliderQuestionOverlayLikeCls", _11 as "quizImageSliderQuestionOverlayLikeIconCls", _12 as "quizImageSliderQuestionTextCls", _13 as "quizProgressBarHeight", _14 as "raContainerHeightCorrectionLg", _15 as "raContainerHeightCorrectionMd", _16 as "raContainerHeightCorrectionSm", _17 as "raImageHeightCorrectionLg", _18 as "raImageHeightCorrectionMd", _19 as "raImageHeightCorrectionSm" }
